class TransportChainScenarioService {
  constructor (http) {
    this.http = http
  }

  async calculate (scenario) {
    const result = await this.http.post('/transport-chain-scenario', { ...scenario, incotermId: scenario.incotermId.id })
    return result.data
  }

  async getChoices () {
    const result = await this.http.get('/transport-chain-scenario/choices')
    return result.data
  }
}

export default TransportChainScenarioService
